import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { capturarOrigem, rastrear } from '../../services/tracking'

const MARCOS_ROLAGEM = [25, 50, 75, 100]

/**
 * Registra cada página visitada no site e até onde o visitante rolou
 * (Links de Campanhas). Deve ficar dentro do <Router>.
 */
export default function RastreadorDePaginas() {
  const location = useLocation()

  useEffect(() => {
    capturarOrigem(location.search)
    rastrear('page_view', { pagina: location.pathname })

    const atingidos = new Set()
    const aoRolar = () => {
      const doc = document.documentElement
      const alturaUtil = doc.scrollHeight - window.innerHeight
      const percentual = alturaUtil <= 0 ? 100 : Math.round((window.scrollY / alturaUtil) * 100)
      MARCOS_ROLAGEM.forEach((marco) => {
        if (percentual >= marco && !atingidos.has(marco)) {
          atingidos.add(marco)
          rastrear('scroll', { pagina: location.pathname, dados: { percentual: marco } })
        }
      })
    }
    window.addEventListener('scroll', aoRolar, { passive: true })
    return () => window.removeEventListener('scroll', aoRolar)
  }, [location.pathname, location.search])

  return null
}
